// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-content {
  padding: 16px 24px 24px 24px;
}
.app-content .main-section {
  background-color: #fff;
  border-top: 1px solid #e6e6e6;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  flex-grow: 1;
  min-height: 100vh;
  padding: 0 1.25rem 24px 1.25rem;
  margin-bottom: 24px;
}
.app-content .header-section {
  margin: 20px 0px;
}
.app-content .ant-layout-content.page-content .ant-table-wrapper {
  margin: 0px 0px 20px 0px;
}
.app-content .schema-builder.no-lines form .schema-column .column-inner {
  border: none;
}
.app-content .schema-builder.no-lines form .schema-column .column-inner .schema-row .schema-vertical-line {
  border: none;
}
.app-content .schema-builder form {
  width: 100%;
}
.app-content .schema-builder form .schema-column .column-inner {
  margin-left: 30px;
}
.app-content .schema-builder form .schema-column .column-inner .button-holder .plus-button {
  margin-top: 20px;
  margin-left: -20px;
}
.app-content .schema-builder form .schema-column .column-inner {
  border-left: 1px solid black;
}
.app-content .schema-builder form .schema-column .column-inner.root {
  border-left: none;
  position: relative;
}
.app-content .schema-builder form .schema-column .column-inner .root-line {
  border-left: 1px solid black;
  position: absolute;
  top: 35px;
  left: -1px;
  bottom: 0px;
}
.app-content .schema-builder form .schema-column .column-inner .button-holder .button-line {
  position: relative;
  margin-top: 16px;
  margin-left: -1px;
  height: 16px;
  width: 25px;
  border-left: 1px solid black;
  border-bottom: 1px solid black;
}
.app-content .schema-builder form .schema-column .column-inner .button-holder .button-line .plus-button {
  position: absolute;
  margin-top: 0px;
  margin-left: 15px;
  top: -1px;
}
.app-content .schema-builder form .schema-column .column-inner .schema-row .schema-vertical-line {
  height: 16px;
  width: 25px;
  margin-left: -1px;
  border-left: 1px solid black;
  border-bottom: 1px solid black;
}
.app-content .schema-builder form .schema-column .column-inner .schema-row .schema-vertical-line.first {
  border-left: none;
}
.app-content .schema-builder form .schema-column .schema-row {
  padding-top: 20px;
}
.app-content .schema-builder form .schema-column .schema-row .schema-vertical-line {
  border: none;
}
`, "",{"version":3,"sources":["webpack://./src/app/styles.less"],"names":[],"mappings":"AAAA;EACE,4BAAA;AACF;AAFA;EAII,sBAAA;EACA,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,+BAAA;EACA,mBAAA;AACJ;AAbA;EAeI,gBAAA;AACJ;AAhBA;EAmBM,wBAAA;AAAN;AAMI;EAIO,YAAA;AAPX;AAGI;EAOY,YAAA;AAPhB;AAzBA;EAyCM,WAAA;AAbN;AA5BA;EA6CU,iBAAA;AAdV;AA/BA;EAiDc,gBAAA;EACA,kBAAA;AAfd;AAnCA;EAwDU,4BAAA;AAlBV;AAoBU;EACE,iBAAA;EACA,kBAAA;AAlBZ;AA1CA;EAgEY,4BAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;AAnBZ;AAjDA;EAyEc,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,4BAAA;EACA,8BAAA;AArBd;AA1DA;EAkFgB,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,SAAA;AArBhB;AAhEA;EA6Fc,YAAA;EACA,WAAA;EACA,iBAAA;EACA,4BAAA;EACA,8BAAA;AA1Bd;AA4Bc;EACE,iBAAA;AA1BhB;AA1EA;EA2GU,iBAAA;AA9BV;AA7EA;EA8GY,YAAA;AA9BZ","sourcesContent":[".app-content {\n  padding: 16px 24px 24px 24px;\n\n  .main-section {\n    background-color: #fff;\n    border-top: 1px solid #e6e6e6;\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    flex-grow: 1;\n    min-height: 100vh;\n    padding: 0 1.25rem 24px 1.25rem;\n    margin-bottom: 24px;\n  }\n  .header-section {\n    margin: 20px 0px;\n  }\n  .ant-layout-content.page-content {\n    .ant-table-wrapper {\n      margin: 0px 0px 20px 0px;\n    }\n  }\n\n  .schema-builder {\n\n    &.no-lines {\n      form{\n       .schema-column {\n         .column-inner {\n           border: none;\n           .schema-row {\n             .schema-vertical-line {\n                border: none;\n             }\n           }\n         }\n       }\n      }\n    }\n\n    form {\n      width: 100%;\n\n      .schema-column {\n        .column-inner {\n          margin-left: 30px;\n\n          .button-holder {\n            .plus-button {\n              margin-top: 20px;\n              margin-left: -20px;\n            }\n          }\n        }\n\n        .column-inner {\n          border-left: 1px solid black;\n\n          &.root {\n            border-left: none;\n            position: relative;\n          }\n\n          .root-line {\n            border-left: 1px solid black;\n            position: absolute;\n            top: 35px;\n            left: -1px;\n            bottom: 0px;\n          }\n\n          .button-holder {\n            .button-line {\n              position: relative;\n              margin-top: 16px;\n              margin-left: -1px;\n              height: 16px;\n              width: 25px;\n              border-left: 1px solid black;\n              border-bottom: 1px solid black;\n\n              .plus-button {\n                position: absolute;\n                margin-top: 0px;\n                margin-left: 15px;\n                top: -1px;\n              }\n\n            }\n          }\n\n          .schema-row {\n            .schema-vertical-line {\n              height: 16px;\n              width: 25px;\n              margin-left: -1px;\n              border-left: 1px solid black;\n              border-bottom: 1px solid black;\n\n              &.first {\n                border-left: none;\n              }\n            }\n          }\n        }\n\n        .schema-row {\n          padding-top: 20px;\n\n          .schema-vertical-line {\n            border: none;\n          }\n        }\n      }\n    }\n  }\n  }\n@error-color: #EB0004;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
